import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === "admin" && password === "Roman@2025") {
      localStorage.setItem("adminLoggedIn", "true");
      toast.success("Login successful!");
      navigate("/admin");
    } else {
      toast.error("Invalid credentials");
    }
  };

  return (
    <div style={{minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f3f4f6"}}>
      <div style={{background: "white", padding: "40px", borderRadius: "10px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)", width: "100%", maxWidth: "400px"}}>
        <h1 style={{textAlign: "center", marginBottom: "30px", fontSize: "24px", fontWeight: "bold"}}>Admin Login</h1>
        <form onSubmit={handleLogin}>
          <input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} style={{width: "100%", padding: "12px", marginBottom: "15px", border: "1px solid #ddd", borderRadius: "5px", boxSizing: "border-box"}} />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} style={{width: "100%", padding: "12px", marginBottom: "20px", border: "1px solid #ddd", borderRadius: "5px", boxSizing: "border-box"}} />
          <button type="submit" style={{width: "100%", padding: "12px", background: "#2563eb", color: "white", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "16px"}}>Login</button>
        </form>
      </div>
    </div>
  );
}
